export default __webpack_public_path__ + "static/media/gatlins.f07dfcba.jpg";